import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import AboutEratekImageWrapper from "./AboutEratekImageWrapper";
import AboutEratekDetails from "./AboutEratekDetails";
import "./AboutEratek1KB.css";

export default function AboutEratek1KB() {




  return (
    <section
      id="about"
      className="section about-one-kb py-4"
    >
      <Container>
        <Row>
          <Col
            sm={{ span: 12, order: 1 }}
            md={{ span: 6, order: 1 }}
            lg={{ span: 5, order: 1 }}
            style={{
              paddingRight: "3rem"
            }}
          >
            <AboutEratekImageWrapper
            />
          </Col>

          <Col
            xs={{ span: 12, order: 2 }}
            md={{ span: 6, order: 2 }}
            lg={{ span: 6, order: 2 }}
          >
            <AboutEratekDetails />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

